"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgAdminRoute = exports.OrgTokenRoute = exports.OrgAgentRoute = void 0;
/**
 * Routes to API endpoints requiring valid auth bearer token generated by/for specific organization
 */
exports.OrgAgentRoute = {
    OrgFetchRuntimeScript: '/api/v1/auth/org/:organizationUid/runtime_scripts/:scriptRunnerType/build/:scriptBuildUid.js',
    OrgAutomationAsApiEndpoint: '/api/v1/auth/org/:organizationUid/endpoint/:endpointCode/:remainder*',
    OrgSecretConfig: '/api/v1/auth/org/:organizationUid/secrets/service_connection/:serviceConnUid',
    OrgSecretForAlias: '/api/v1/auth/org/:organizationUid/secrets/named/:orgAlias',
    OrgExpiringPageCrud: '/api/v1/auth/org/:organizationUid/expiring_pages/:pageDefUid?',
    OrgRegisterTaskRunner: '/api/v1/auth/org/:organizationUid/register_task_runner',
    OrgTaskRunnerWsRelay: '/api/v1/auth/org/:organizationUid/ws_sync_relay',
};
/**
 * Routes to endpoints authenticated using an expiring token generated during runtime
 */
exports.OrgTokenRoute = {
    OrgPageDataAuth: '/api/v1/page_data/org/:organizationUid/token/:pageDefUid/auth',
    OrgPageDataFetch: '/api/v1/page_data/org/:organizationUid/token/:pageDefUid/fetch',
    OrgPageDataSubmit: '/api/v1/page_data/org/:organizationUid/token/:pageDefUid/submit',
    /**
     * For @koa/router. It's rejecting cors OPTIONS requests with 404 before the cors middleware gets it. :/
     * (Note: app.use(router.allowedMethods()); doesn't seem to work when applied to subroutes, and breaks non-browser-facing responses)
     */
    CorsOptionsForBrowserRequests_PageData: '/api/v1/page_data/org/:organizationUid/token/(.*)',
    OrgCallbackResolution: '/api/v1/external_task/org/:organizationUid/token/:callbackTokenUid/resolve_task',
    OrgRuntimeExternalLogEntry: '/api/v1/external_task/org/:organizationUid/token/:callbackTokenUid/logger',
    OrgRuntimeExternalInfoForUser: '/api/v1/external_task/org/:organizationUid/token/:callbackTokenUid/info_for_user',
};
/**
 * Routes to endpoints similar to OrgAgentRoute (via auth bearer token) but requiring full admin permission to organization
 */
exports.OrgAdminRoute = {
    AuthoringMutator: '/api/v1/admin/org/:organizationUid/authoring/mutate',
    AuthoringProjectsOverview: '/api/v1/admin/org/:organizationUid/authoring/projects_overview',
    FetchProject: '/api/v1/admin/org/:organizationUid/authoring/project/:authoringProjectUid',
    FetchOrgLevelConstructs: '/api/v1/admin/org/:organizationUid/authoring/org_elements',
    ForceStartAutomation: '/api/v1/admin/org/:organizationUid/runtime/force_start_project/:authoringProjectUid'
};
//# sourceMappingURL=routes-org-stable-api.js.map